import { Label as Icon } from "@mui/icons-material";
import { ListItemIcon, ListItemText, MenuItem, Select } from "@mui/material";
import "./SelectWithColors.scss";

interface Props<T extends string> {
  readonly values: { id: T; label: string }[];
  readonly value: T;
  readonly colors: { [key: string]: string };
  readonly label?: string;
  readonly onChange: (value: T) => void | Promise<void>;
}

export const SelectWithColors = <T extends string>({ values, value, colors, label, onChange }: Props<T>) => (
  <Select
    value={value}
    style={{
      backgroundColor: colors[value],
    }}
    onChange={(e) => onChange(e.target.value as T)}
    fullWidth
    aria-label={label}
    className="EnumSelect"
  >
    {values.map((e) => (
      <MenuItem key={e.id} value={e.id}>
        <ListItemIcon>
          <Icon
            style={{
              color: colors[e.id],
            }}
          />
        </ListItemIcon>
        <ListItemText>{e.label}</ListItemText>
      </MenuItem>
    ))}
  </Select>
);
